import { Button, Form, Input, message, Select } from 'antd';
import { NotificationTemplateFilterFormFieldList, NotificationTemplateFilterFormValues } from 'features/notification/components/type';
import { useCreateNotificationTemplate } from 'features/notification/use-cases/create-template';
import { useGetDropDownData } from 'features/notification/use-cases/get-common-api-data';
import { FormSectionsSeparator } from 'features/users/components/modals/form-sections-separator';
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import ReactQuill from 'react-quill';

export const AddNotificationTemplateModal = ({
    onClose,
    refetch,
    templateEditData
}: {
    onClose: () => void;
    showAddItemModal: boolean;
    refetch: () => void;
    templateEditData: any;
}) => {
    const formName = 'add-notification-template-form';
    const [form] = Form.useForm<NotificationTemplateFilterFormValues>();
    const { t } = useTranslation();
    const { isLoading, mutate } = useCreateNotificationTemplate();
    const imageInputRef = useRef<HTMLInputElement>(null);
    const imageArInputRef = useRef<HTMLInputElement>(null);
    const [fileNameEn, setFileNameEn] = useState<string>('');
    const [fileNameAr, setFileNameAr] = useState<string>('');
    const [validateTrigger, setValidateTrigger] = useState(['onSubmit']);
    const [imagePreview, setImagePreview] = useState<string | null>(null);
    const [templateImageAr, setTemplateImageAr] = useState<File | null>(null);
    const [templateImage, setTemplateImage] = useState<File | null>(null);
    const [imagePreviewAr, setImagePreviewAr] = useState<string | null>(null);

    const [contentEn, setContentEn] = useState<string>("");
    const [contentAr, setContentAr] = useState<string>("");
    const title = Form.useWatch(
        NotificationTemplateFilterFormFieldList.TITLE,
        form
    );
    const getFileNameFromUrl = (url: string) => {
        return url?.split('/').pop() || '';
    };
    const titlear = Form.useWatch(
        NotificationTemplateFilterFormFieldList.TITLEAR,
        form
    );
    const handleFileChange = (
        e: React.ChangeEvent<HTMLInputElement>
    ) => {
        const file = e.target.files?.[0];

        if (!file) return;

        const img = new Image();
        const objectUrl = URL.createObjectURL(file);

        img.onload = () => {
            const width = img.width;
            const height = img.height;

            const aspectRatio = width / height;
            const expectedRatio = 16 / 9;

            // Validate 16:9 aspect ratio
            const isValidRatio =
                Math.abs(aspectRatio - expectedRatio) < 0.01;

            if (!isValidRatio) {
                message.error(
                    `Invalid image dimensions: ${width}x${height}. Please upload a 16:9 image.`
                );

                // Clear input
                if (imageInputRef.current) {
                    imageInputRef.current.value = "";
                }

                // Clear previous image
                setTemplateImage(null);
                setImagePreview(null);
                setFileNameEn("");

                URL.revokeObjectURL(objectUrl);

                return;
            }

            // ✅ Valid 16:9 image
            setTemplateImage(file);
            setImagePreview(objectUrl);
            setFileNameEn(file.name);

            message.success("Image uploaded successfully.");

            // ❌ Don't revoke objectUrl here,
            // because imagePreview is using it.
        };

        img.onerror = () => {
            message.error("Invalid image file.");

            if (imageInputRef.current) {
                imageInputRef.current.value = "";
            }

            setTemplateImage(null);
            setImagePreview(null);
            setFileNameEn("");

            URL.revokeObjectURL(objectUrl);
        };

        img.src = objectUrl;
    };

    // const titleAr = Form.useWatch(
    //     NotificationTemplateFilterFormFieldList.TITLEAR,
    //     form
    // );

    // ✅ Dropdown data
    const { data: notificationModalType } = useGetDropDownData({
        flag: "announcementtype",
        searchId: 0,
        SearchKey: ""
    });

    // useEffect(() => {
    //     if (templateEditData) {
    //         form.setFieldsValue(templateEditData);

    //         setContentEn(templateEditData.ContentEn || "");
    //         setContentAr(templateEditData.ContentAr || "");
    //         setImagePreview(templateEditData.ImageUrl || null);
    //         setImagePreviewAr(templateEditData?.ArabicImage_Url || null)

    //         setTemplateImage(null);
    //         if (imageInputRef.current) imageInputRef.current.value = '';
    //         if (imageArInputRef.current) imageArInputRef.current.value = '';
    //     } else {
    //         form.resetFields();
    //         setImagePreview(null);
    //         setTemplateImage(null);
    //         setImagePreviewAr(null)

    //         setContentEn("");
    //         setContentAr("");
    //         // if (imageInputRef.current) imageInputRef.current.value = '';
    //         //     if (imageArInputRef.current) imageArInputRef.current.value = '';
    //     }
    // }, [templateEditData]);
    useEffect(() => {
        if (templateEditData) {
            form.setFieldsValue(templateEditData);

            setContentEn(templateEditData.ContentEn || "");
            setContentAr(templateEditData.ContentAr || "");

            setImagePreview(templateEditData.ImageUrl || null);
            setImagePreviewAr(templateEditData?.ArabicImage_Url || null);

            // ✅ Set filenames from API
            setFileNameEn(getFileNameFromUrl(templateEditData.ImageUrl));
            setFileNameAr(getFileNameFromUrl(templateEditData.ArabicImage_Url));

            if (imageInputRef.current) imageInputRef.current.value = '';
            if (imageArInputRef.current) imageArInputRef.current.value = '';
        }
    }, [templateEditData]);

    const handleClose = () => {
        onClose();
        {
            if (!templateEditData) {
                form.resetFields();          // resets AntD form fields
                setImagePreview(null);       // resets preview
                setTemplateImage(null);
                setTemplateImageAr(null);    // reset AR image
                setContentEn("");            // reset English editor
                setContentAr("");            // reset Arabic editor
                if (imageInputRef.current) imageInputRef.current.value = '';
                if (imageArInputRef.current) imageArInputRef.current.value = '';
            }
        }
        // Reset file input values (clear selected file names)
    };

    // ✅ Image upload
    // const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    //     const file = e.target.files?.[0];
    //     if (file) {
    //         setTemplateImage(file);
    //         setImagePreview(URL.createObjectURL(file));
    //         setFileNameEn(file.name); // ✅ set name
    //     }
    // };

    // const handleFileChangeAr = (e: React.ChangeEvent<HTMLInputElement>) => {
    //     const file = e.target.files?.[0];
    //     if (file) {
    //         setTemplateImageAr(file);
    //         setImagePreviewAr(URL.createObjectURL(file));
    //         setFileNameAr(file.name); // ✅ set name
    //     }
    // };
    const handleFileChangeAr = (
        e: React.ChangeEvent<HTMLInputElement>
    ) => {
        const file = e.target.files?.[0];

        if (!file) return;

        const img = new Image();
        const objectUrl = URL.createObjectURL(file);

        img.onload = () => {
            const width = img.width;
            const height = img.height;

            const aspectRatio = width / height;
            const expectedRatio = 16 / 9;

            // Validate 16:9 aspect ratio
            const isValidRatio =
                Math.abs(aspectRatio - expectedRatio) < 0.01;

            if (!isValidRatio) {
                message.error(
                    `Invalid image dimensions: ${width}x${height}. Please upload a 16:9 image.`
                );



                setFileNameAr("");
                setTemplateImageAr(null);
                setImagePreviewAr("");

                URL.revokeObjectURL(objectUrl);

                return;
            }

            // Valid 16:9 image
            setTemplateImageAr(file);
            setImagePreviewAr(objectUrl);
            setFileNameAr(file.name);

            message.success("Arabic image uploaded successfully.");
        };

        img.onerror = () => {
            message.error("Invalid image file.");


            setFileNameAr("");
            setTemplateImageAr(null);
            setImagePreviewAr("");

            URL.revokeObjectURL(objectUrl);
        };

        img.src = objectUrl;
    };
    const handleUpdate = (formData: any) => {

        formData[NotificationTemplateFilterFormFieldList.CONTENTEN] = contentEn;
        formData[NotificationTemplateFilterFormFieldList.CONTENTAR] = contentAr;

        if (templateEditData?.Id) {
            formData[NotificationTemplateFilterFormFieldList.ID] = templateEditData.Id;
            formData[NotificationTemplateFilterFormFieldList.ANNOUNCEMENTTYPEID] =
                templateEditData.AnnouncementTypeId;
        }
        if (templateImage) {
            formData[NotificationTemplateFilterFormFieldList.IMAGE] = templateImage;
        }
        if (templateImageAr) {
            formData[NotificationTemplateFilterFormFieldList.IMAGEAR] = templateImageAr;
        }
        mutate(formData, {
            onSuccess: () => {
                handleClose();
                refetch();
            }
        });
    };

    return (
        <div className='popup template_modal'>
            <div className='modal_head'>
                <h4>
                    {templateEditData?.Id ? 'Update' : 'Create'} Notification Template
                </h4>
                <button onClick={handleClose} className='close-btn'>
                    &times;
                </button>
            </div>

            <div className='modal_body'>

                <div>

                    <Form
                        id={formName}
                        form={form}
                        layout='vertical'
                        onFinish={handleUpdate}
                        validateTrigger={validateTrigger}
                        disabled={isLoading}
                        onFinishFailed={() => setValidateTrigger(['onChange'])}
                        requiredMark={true}
                        scrollToFirstError
                    >


                        <div className='templte_review'>
                            <div >
                                <FormSectionsSeparator title={""}>

                                    <Form.Item
                                        label="Template Name"
                                        name={NotificationTemplateFilterFormFieldList.TEMPLATENAME}
                                        rules={

                                            [{ required: true, message: t('validateMessages.custom.nomsg') }]

                                        }
                                    >
                                        <Input placeholder="Enter Template Name" />
                                    </Form.Item>

                                    <Form.Item
                                        label="Notification Type"
                                        name={NotificationTemplateFilterFormFieldList.ANNOUNCEMENTTYPEID}
                                        rules={

                                            [{ required: true, message: t('validateMessages.custom.nomsg') }]

                                        }
                                    >
                                        <Select
                                            placeholder="Select Type"
                                            options={notificationModalType?.notificationDropDownList?.map((res: any) => ({
                                                label: res.title,
                                                value: res.id
                                            }))}
                                            allowClear
                                        />
                                    </Form.Item>

                                    <Form.Item
                                        label="English Notification Title"
                                        name={NotificationTemplateFilterFormFieldList.TITLE}
                                        rules={[{ required: true, message: t('validateMessages.custom.nomsg') }]}
                                    >
                                        <Input placeholder="Enter Notification Title" />
                                    </Form.Item>

                                    <Form.Item
                                        label="Arabic Notification Title"
                                        name={NotificationTemplateFilterFormFieldList.TITLEAR}
                                        style={{ direction: "rtl", textAlign: "right" }}
                                        rules={[{ required: true, message: t('validateMessages.custom.nomsg') }]}
                                    >
                                        <Input
                                            placeholder="Enter Notification TitleAr"
                                            style={{ direction: "rtl", textAlign: "right" }}
                                        />
                                    </Form.Item>

                                    {/* EN Editor */}
                                    {/* <Form.Item label="English Message">
                            <ReactQuill
                                theme="snow"
                                value={contentEn}
                                onChange={setContentEn}
                                modules={AddNotificationTemplateModal.modules}
                                formats={AddNotificationTemplateModal.formats}
                            />
                        </Form.Item> */}
                                    <Form.Item
                                        label="English Message"
                                        name={NotificationTemplateFilterFormFieldList.CONTENTEN}
                                        valuePropName="value"
                                        getValueFromEvent={(value) => value}
                                        rules={[
                                            { required: true, message: "Message is required" }
                                        ]}
                                    >
                                        <ReactQuill
                                            className="editor-small cstm_editor "
                                            theme="snow"
                                            value={contentEn || ""}
                                            onChange={setContentEn}

                                            modules={AddNotificationTemplateModal.modules}
                                            formats={AddNotificationTemplateModal.formats}
                                            placeholder="Enter your message here..."
                                        // dangerouslySetInnerHTML={{ __html: code }}
                                        // readOnly={!edit}
                                        />
                                    </Form.Item>

                                    {/* AR Editor */}
                                    {/* <Form.Item label="Arabic Message"
                            className="arabic-editor"
                            style={{ direction: "rtl", textAlign: "right" }}>
                            <ReactQuill
                                theme="snow"
                                value={contentAr}
                                onChange={setContentAr}
                                modules={AddNotificationTemplateModal.modules}
                                formats={AddNotificationTemplateModal.formats}
                                style={{ direction: "rtl", textAlign: "right" }}

                            />
                        </Form.Item> */}
                                    <Form.Item
                                        className="arabic-editor"
                                        label="Arabic Message"
                                        style={{ direction: "rtl", textAlign: "right" }}

                                        name={NotificationTemplateFilterFormFieldList.CONTENTAR}
                                        valuePropName="value"
                                        getValueFromEvent={(value) => value}
                                        rules={[
                                            { required: true, message: "MessageAr is required" }
                                        ]}
                                    >
                                        <ReactQuill
                                            className="editor-small cstm_editor"
                                            theme="snow"
                                            value={contentAr || ""}
                                            onChange={setContentAr}
                                            modules={AddNotificationTemplateModal.modules}
                                            formats={AddNotificationTemplateModal.formats}
                                            placeholder="Enter your message here..."
                                        />
                                    </Form.Item>

                                    {/* Image Upload */}
                                    {/* <Form.Item label="English Image">
                                        <Input
                                            type="file"
                                            onChange={handleFileChange}
                                            accept=".png,.jpg,.jpeg"
                                            ref={imageInputRef as any}
                                        />
                                        <div style={{ marginTop: 5, fontSize: 12, color: '#888' }}>
                                            Recommended size: <strong>1920 × 1080 px (16:9)</strong>
                                            <br />
                                        </div>
                                        {fileNameEn && (
                                            <div style={{ marginTop: 5, fontSize: 12, color: '#555' }}>
                                                Selected: {fileNameEn}
                                            </div>

                                        )}
                                    </Form.Item> */}
                                    <Form.Item label="English Image">
                                        <div
                                            onClick={() => imageInputRef.current?.click()}
                                            style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                width: '100%',
                                                height: '32px',
                                                border: '1px solid #bfbfbf',
                                                borderRadius: '6px',
                                                background: '#fff',
                                                cursor: 'pointer',
                                                overflow: 'hidden',
                                                padding: '0 4px',
                                                boxSizing: 'border-box',
                                            }}
                                        >
                                            {/* Hidden file input */}
                                            <input
                                                id="english-image"
                                                type="file"
                                                onChange={handleFileChange}
                                                accept=".png,.jpg,.jpeg"
                                                ref={imageInputRef}
                                                style={{ display: 'none' }}
                                            />

                                            {/* Choose File Button */}
                                            <span
                                                style={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    height: '24px',
                                                    padding: '0 10px',
                                                    border: '1px solid #d9d9d9',
                                                    borderRadius: '4px',
                                                    background: '#f5f5f5',
                                                    color: '#333',
                                                    fontSize: '13px',
                                                    whiteSpace: 'nowrap',
                                                    flexShrink: 0,
                                                }}
                                            >
                                                Choose file
                                            </span>

                                            {/* Selected file name */}
                                            <span
                                                style={{
                                                    marginLeft: '8px',
                                                    fontSize: '13px',
                                                    color: fileNameEn ? '#333' : '#999',
                                                    overflow: 'hidden',
                                                    textOverflow: 'ellipsis',
                                                    whiteSpace: 'nowrap',
                                                }}
                                            >
                                                {fileNameEn || 'No file chosen'}
                                            </span>
                                        </div>

                                        <div
                                            style={{
                                                marginTop: 5,
                                                fontSize: 12,
                                                color: '#888',
                                            }}
                                        >
                                            Recommended size:{' '}
                                            <strong>1920 × 1080 px (16:9)</strong>
                                        </div>
                                    </Form.Item>

                                    <Form.Item label="Arabic Image">
                                        <div
                                            onClick={() => imageArInputRef.current?.click()}
                                            style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                width: '100%',
                                                height: '32px',
                                                border: '1px solid #bfbfbf',
                                                borderRadius: '6px',
                                                background: '#fff',
                                                cursor: 'pointer',
                                                overflow: 'hidden',
                                                padding: '0 4px',
                                                boxSizing: 'border-box',
                                            }}
                                        >
                                            {/* Hidden file input */}
                                            <input
                                                id="arabic-image"
                                                type="file"
                                                onChange={handleFileChangeAr}
                                                accept=".png,.jpg,.jpeg"
                                                ref={imageArInputRef}
                                                style={{ display: 'none' }}
                                            />

                                            {/* Choose File Button */}
                                            <span
                                                style={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    height: '24px',
                                                    padding: '0 10px',
                                                    border: '1px solid #d9d9d9',
                                                    borderRadius: '4px',
                                                    background: '#f5f5f5',
                                                    color: '#333',
                                                    fontSize: '13px',
                                                    whiteSpace: 'nowrap',
                                                    flexShrink: 0,
                                                }}
                                            >
                                                Choose file
                                            </span>

                                            {/* Selected file name */}
                                            <span
                                                style={{
                                                    marginLeft: '8px',
                                                    fontSize: '13px',
                                                    color: fileNameAr ? '#333' : '#999',
                                                    overflow: 'hidden',
                                                    textOverflow: 'ellipsis',
                                                    whiteSpace: 'nowrap',
                                                }}
                                            >
                                                {fileNameAr || 'No file chosen'}
                                            </span>
                                        </div>

                                        <div
                                            style={{
                                                marginTop: 5,
                                                fontSize: 12,
                                                color: '#888',
                                            }}
                                        >
                                            Recommended size:{' '}
                                            <strong>1920 × 1080 px (16:9)</strong>
                                        </div>
                                    </Form.Item>
                                </FormSectionsSeparator>
                            </div>
                            <Form.Item className='preview_dtl'>

                                <div

                                >
                                    <div
                                        style={{
                                            background: '#f0f0f0',
                                            borderRadius: 4,
                                            padding: 16,


                                        }}
                                    >

                                        <h4>Your Notification Look Like</h4>
                                        <p>View how your template will appear before final use</p>
                                        <div className='notify_preview'>
                                            <div className='en'>
                                                <h3 >English Preview</h3>
                                                <div className='eng_prviw'>

                                                    <div style={{ fontWeight: 500, marginBottom: 8 }}>
                                                        {title || 'Notification Title'}
                                                    </div>
                                                    <div
                                                        style={{ color: '#555' }}
                                                        dangerouslySetInnerHTML={{
                                                            __html: contentEn || 'No description here'
                                                        }}
                                                    />
                                                    {imagePreview && (
                                                        <div className='img_box'>
                                                            <img
                                                                src={imagePreview}
                                                                alt="Preview EN"
                                                                style={{
                                                                    width: '130px',
                                                                    marginTop: 10,
                                                                    borderRadius: 6
                                                                }}

                                                            />
                                                        </div>
                                                    )}
                                                </div>
                                            </div>

                                            <div className='ar'>
                                                <h3 >Arabic Preview</h3>
                                                <div className='eng_prviw'>
                                                    <div style={{ fontWeight: 500, marginBottom: 8 }}>
                                                        {titlear || 'Notification Title'}
                                                    </div>
                                                    <div
                                                        style={{ color: '#555' }}
                                                        dangerouslySetInnerHTML={{
                                                            __html: contentAr || 'No description here'
                                                        }}
                                                    />
                                                    <div className='img_box'>
                                                        {imagePreviewAr && (
                                                            <img
                                                                src={imagePreviewAr}
                                                                alt="Preview AR"
                                                                style={{
                                                                    width: '130px',
                                                                    marginTop: 10,
                                                                    borderRadius: 6
                                                                }}
                                                            />

                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Form.Item>
                        </div>

                        <div className='form-button'>
                            <Button htmlType='submit' type='primary'>
                                Save Template
                            </Button>
                        </div>

                    </Form>
                </div>
            </div>
        </div >
    );
};

// Editor config
AddNotificationTemplateModal.modules = {
    toolbar: [
        [{ header: [1, 2, 3, false] }],
        ['bold', 'italic', 'underline'],
        [{ list: 'ordered' }, { list: 'bullet' }],
        ['link'],
        ['clean']
    ]
};

AddNotificationTemplateModal.formats = [
    'header', 'bold', 'italic', 'underline',
    'list', 'bullet', 'link'
];